import '@/app.css';
import '@/app/lib/i18next';

import React from 'react';
import ReactDOM from 'react-dom/client';

import checkBrowser from '@/app/lib/check-browser';
import { AppRouter } from '@/app/router';
import { BugsnagErrorBoundary } from '@/shared/components/errors/bugsnag-error-boundary';
import { UnhandledErrorBoundary } from '@/shared/components/errors/unhandled-error-boundary';

const browser = checkBrowser();
if (browser.unsupported) {
  document.getElementById('unsupported-browser')!.style.display = 'block';
} else {
  const rootElement = document.getElementById('root')!;

  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <UnhandledErrorBoundary>
          <BugsnagErrorBoundary>
            <AppRouter />
          </BugsnagErrorBoundary>
        </UnhandledErrorBoundary>
      </React.StrictMode>
    );
  }
}
